import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-trust-section',
  templateUrl: './trust-section.component.html',
  styleUrl: './trust-section.component.scss'
})
export class TrustSectionComponent {
  @Input() title!: string;
  @Input() subtitle!: string;
}
